import { http } from '../utilities/http'
import { config } from '../utilities/configs'

let NewsEventService = {
  get: async (page) => {
    let url = config.baseUrl + '/newsevent/list'
    if (page) url += `?page=${page}`

    const resp = await http.get(url)
    return resp
  },
}

export { NewsEventService }
